import { ShieldAlert } from 'lucide-react';
import React from 'react';

interface Props {
  count: number;
  total: number;
  currency: string;
}

export const AdvancePaymentsAlert: React.FC<Props> = ({
  count,
  total,
  currency,
}) => {
  if (count === 0) return null;
  return (
    <div className="flex items-center justify-between rounded-2xl border border-amber-200 bg-amber-50 px-5 py-4">
      <div className="flex items-center gap-3">
        <div className="rounded-xl bg-amber-400/20 p-2.5">
          <ShieldAlert size={18} className="text-amber-700" />
        </div>
        <div>
          <p className="text-sm font-semibold text-amber-800">
            Advance payments
          </p>
          <p className="text-xs text-amber-600">
            {count} booking{count !== 1 ? 's' : ''} with payments not yet
            checked in
          </p>
        </div>
      </div>
      <div className="text-right">
        <p className="text-lg font-bold text-amber-800">
          {currency} {total.toLocaleString()}
        </p>
        <p className="text-[10px] text-amber-600">Total amount paid</p>
      </div>
    </div>
  );
};
